<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Escovação supervisionada"
            description="Escovação supervisionada em pessoas de 6 a 12 anos"
            url="/saude-bucal"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Escovação Supervisionada',
    titleTemplate: null,
  },
  data() {
    return {
      linksAjudaPec: [],
      linksAjudaCds: [],
    }
  },
}
</script>

<style></style>
